module.exports = "https://staticsandbox.coteibem.com.br/assets/modal-close-white.fd345dd46bb96c3919a046f44ef470d5.svg";